<template>
    <div id="content" ref='container' >
        <div v-show="isLoading" class="loading-wraper">
            <img
                class="loading"
                src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/fontend-activity/loading.be43c23130aad283.svg"
            />
        </div>
        <div ref="app" class="app-show-box" id='app' >
            <div class="app-bar-msg" :style="{'border-bottom': isPlayEnd ? '0.01rem solid rgba(255,255,255,0.08)' : ''}">
                <div class='app-bar-info' v-if='showShareInfo'>
                    <div class='app-bar-icon'>
                        <img :src="userInfo.iconUrlList[0]" class='icon-img'/>
                    </div>
                    <div class='app-bar-txt'>
                        <div class="nick-name">{{userInfo.nickName}}</div>
                        <div class="des" v-if='registerDays<10'>正在使用<span style="color:rgba(255,80,0,1)">快影</span>，邀请你一起创作精彩视频</div>
                        <div class="des" v-else>在快影等你<span style="color:#F7365D">{{registerDays}}</span>天</div>
                    </div>
                </div>

                <div class='app-bar-info' v-else>
                    <div class='app-bar-icon'>
                        <img :src="shareUserIcon" class='ky-icon'/>
                    </div>
                    <div class='app-bar-txt'>
                        <div class="no-user">快影 ｜ 爆款短视频一键制作</div>
                    </div>
                </div>
                <div class='app-bar-btn'>
                    <template v-if="isWexin">
                        <WxOpenTag :extInfo="openMvTabUrl" :errorHandler="wxOpenHandler">
                            <div class='btn-txt'>去看看</div>
                        </WxOpenTag>
                    </template>
                    <div v-else class='btn-txt' @click="openKy('epx1-try', openMvTabUrl)">去看看</div>
                </div>
            </div>
            <div id='main-video' v-if='show'>
                <div class="app-video-box" v-if="show">
                    <Video
                        class='app-video'
                        :videoId="id"
                        :width="width"
                        :height="height"
                        :source="mainVideoUrl"
                        :cover="mainCoverUrl"
                        :radius="0.16"
                        @isPlayEnd="getPlayState"
                    ></Video>
                </div>
                <div class="app-bottom-fixed" v-show="show">
                    <div class='app-bottom-box'>
                        <div class="app-bottom-user">
                            <div class='user-name'>
                                <p class='user-name'>{{ mainUserName }}</p>
                                <!-- <template v-if="isWexin">
                                    <WxOpenTag :extInfo="openUrl" :errorHandler="wxOpenHandler">
                                        <p>{{ mainUserName }}</p>
                                    </WxOpenTag>
                                </template>
                                <p v-else @click="openKy('userName',openMvTabUrl)">
                                    {{ mainUserName }}
                                </p> -->
                            </div>
                            <div class="template-des">
                                {{ mainVideoDes }}
                            </div>
                        </div>
                        <div class='app-bottom-info'>
                            <div class='info-line'></div>
                            <div class='template-use'>
                                <div class='use-count'>
                                    {{ mainUseCount }}
                                </div>
                                <div class='use-txt'>使用量</div>
                            </div>
                        </div>
                    </div>
                    <div class="app-use-btn">
                        <template v-if="isWexin">
                            <WxOpenTag :extInfo="openUrl" :errorHandler="wxOpenHandler">
                                <div class='app-use-btn'>
                                    <p class='btn-txt'>免费使用同款</p>
                                </div>
                            </WxOpenTag>
                        </template>
                        <div v-else @click="openKy('edit', openUrl)" class='app-use-btn'>
                            <p class='btn-txt'>免费使用同款</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class='recommend-box' id='rec-box' >
                <div class='rec-bar'>
                    <div class='rec-txt'>全网最火模板，尽在快影APP</div>
                    <template v-if="isWexin">
                        <WxOpenTag :extInfo="openMvTabUrl" :errorHandler="wxOpenHandler">
                            <div class='rec-try'>
                                <div class='try-txt'>查看更多</div>
                                <div class='try-arrow'>
                                    <img class='try-img' src='https://p4-ky.wsukwai.com/udata/pkg/kmovie/model-share/more-arrow-a.png' />
                                </div>
                            </div>
                        </WxOpenTag>
                    </template>
                    <div v-else class='rec-try' @click="openKy('exp1-try-more', openMvTabUrl)">
                        <div class='try-txt'>查看更多</div>
                        <div class='try-arrow'>
                            <img class='try-img' src='https://p4-ky.wsukwai.com/udata/pkg/kmovie/model-share/more-arrow-a.png' />
                        </div>
                    </div>
                </div>
                <div class='recommend-video' >
                    <div class='left-feed'>
                        <template v-if="isWexin">
                            <WxOpenTag 
                                v-for="(item,index) in leftData"
                                :key="item.id"
                                :extInfo="`${openMvTabUrl}?id=${item.id}`" :errorHandler="wxOpenHandler"
                            >
                                <template-card
                                    :cardHeight='item.templateBean.height'
                                    :cardWidth="cardWidth"
                                    :useCount='item.templateBean.useCount'
                                    :name='item.user.nickName'
                                    :likeCount='item.likeCount'
                                    :headIcon='item.user.iconUrlList[0]'
                                    :title='item.name'
                                    :mask=' index===0 ? true : false'
                                >
                                    <img :src="item.templateBean.coverUrl || ''" :style="`width: ${cardWidth}px;height:${cardWidth/item.templateBean.width*item.templateBean.height}px;overflow:hidden `"/>
                                </template-card>
                            </WxOpenTag>
                        </template>
                        <template v-else>
                            <template-card
                                v-for="(item,index) in leftData"
                                @onUse="openKy('exp1-card-left', `${openMvTabUrl}?id=${item.id}`)"
                                :key="item.id"
                                :cardHeight='item.templateBean.height'
                                :cardWidth="cardWidth"
                                :useCount='item.templateBean.useCount'
                                :name='item.user.nickName'
                                :likeCount='item.likeCount'
                                :headIcon='item.user.iconUrlList[0]'
                                :title='item.name'
                                :mask=' index===0 ? true : false'
                            >
                                <img :src="item.templateBean.coverUrl || ''" :style="`width: ${cardWidth}px;height:${cardWidth/item.templateBean.width*item.templateBean.height}px;overflow:hidden `"/>
                            </template-card>
                        </template>
                    </div>
                    <div class='right-feed'>
                        <template v-if="isWexin">
                            <WxOpenTag 
                                v-for="(item) in rightData"
                                :key="item.id"
                                :extInfo="`${openMvTabUrl}?id=${item.id}`" :errorHandler="wxOpenHandler"
                            >
                                <template-card
                                    :cardHeight='item.templateBean.height'
                                    :cardWidth="cardWidth"
                                    :useCount='item.templateBean.useCount'
                                    :name='item.user.nickName'
                                    :likeCount='item.likeCount'
                                    :headIcon='item.user.iconUrlList[0]'
                                    :title='item.name'
                                >
                                    <img :src="item.templateBean.coverUrl || ''" :style="`width: ${cardWidth}px;height:${cardWidth/item.templateBean.width*item.templateBean.height}px;overflow:hidden `"/>
                                </template-card>
                            </WxOpenTag>
                        </template>
                        <template v-else>
                            <template-card
                                v-for="(item) in rightData"
                                @onUse="openKy('exp1-card-right', `${openMvTabUrl}?id=${item.id}`)"
                                :key="item.id"
                                :cardHeight="item.templateBean.height"
                                :cardWidth="cardWidth"
                                :useCount='item.templateBean.useCount'
                                :name='item.user.nickName'
                                :likeCount='item.likeCount'
                                :headIcon='item.user.iconUrlList[0]'
                                :title='item.name'
                            >
                                <img :src="item.templateBean.coverUrl || ''" :style="`width: ${cardWidth}px;height:${cardWidth/item.templateBean.width*item.templateBean.height}px;overflow:hidden`"/>
                            </template-card>
                        </template>
                    </div>
                </div>
                <div class='rec-more-box'>
                    <template v-if="isWexin">
                        <WxOpenTag :extInfo="openMvTabUrl" :errorHandler="wxOpenHandler">
                            <div class='rec-more-btn'>
                                <p class='more-btn-txt'>更多精彩模板</p>
                            </div>
                        </WxOpenTag>
                    </template>
                    <div v-else @click="openKy('exp1-more-template', openMvTabUrl)" class='rec-more-btn'>
                        <p class='more-btn-txt'>更多精彩模板</p>
                    </div>
                </div>
            </div>
            <div v-show="showError" class="app-exit-tip">
                <div class="exit-img"></div>
                <div class="exit-text">
                    {{ modelErrorMsg }}
                    <br />{{$t('clickToView')}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Video from '../components/VideoV2.vue';
import TemplateCard  from '../components/templateCard.vue'
import WxOpenTag from '../components/WxOpenTag.vue';
import { getUrlParam } from '@/utils/url';
import { openOrDownloadKwaiying } from '@/utils/device';
import { getCookie } from '@/utils/cookie';
import { get } from '../utils/utils';
import { wxShareConfig, isWexin, wxInit } from '@/utils/wx';
import { WebpMachine } from 'webp-hero';
// 支持webp 格式图片
const webpMachine = new WebpMachine();

export default {
    name: 'auto-feed',
    components: {
        Video,
        WxOpenTag,
        TemplateCard,
    },
    data() {
        return {
            showError: false,
            id: '',
            show: false,
            width: 0,
            height: 0,
            mainUseCount: 0,
            modelErrorMsg: '',
            isWexin: isWexin,
            openUrl: '',
            isLoading: true,
            mainVideoUrl:'',
            mainCoverUrl:'',
            mainUserName:'',
            mainVideoDes:'',
            pageTag: 'kwaiying-template-share',
            userInfo:{},
            showShareInfo:false,
            source: {},
            recData:[],
            mainData:{},
            sameData:[],
            hotData:[],
            leftData: [],
            rightData: [],
            shareUserIcon:'https://p4-ky.wsukwai.com/udata/pkg/kmovie/model-share/ky-icon-v.png',
            openMvTabUrl:'kwaiying://mv',
            isPlayEnd: false,
            cardWidth: (window.screen.width  - 78*window.screen.width /750)/2,
            registerDays:0,
            cardType:'',
            shareCardCount:'',
        };
    },
    props: {
    },
    computed: {
    },
    watch: {
        isPlayEnd: { //深度监听，可监听到对象、数组的变化
            handler() {
                let app = document.getElementById('app')
                let card = document.getElementById('main-video');
                let rec = document.getElementById('rec-box')
                if(this.isPlayEnd){
                    app.style.display= 'block'
                    card.style.transform = 'scale(0.85)'
                    card.style.transitionDuration = "0.7s";
	                card.style.WebkitTransitionDuration = "0.7s";
                    setTimeout(function(){
                        card.style.display = 'none';
                        rec.style.display = 'flex';
                    },500)
                }
            },
            deep: true,
        },
    },
    methods: {
        formalCount(num,type){
            if(num >= 10000){
                if(type == 0){
                    return  (num / 10000).toFixed(1) + 'w';
                }
                else{
                    return  (num / 10000).toFixed(1) + '万';
                }
            }else{
                return num;
            }
        },
        async getAbValue(params){
            const {data} = await get('/rest/n/kmovie/app/resource/getH5Abtest', params);
            console.log('card ab data',data)
            if (data && data.result === 1) {
                this.cardType = data.value;
                return data;
            }
            return Promise.reject(data);
        },
        getPlayState(item){
            this.isPlayEnd = item;
        },
        async getResource(templateId,userId){
            const res = await get('/rest/n/kmovie/app/resource/getTemplateReco', {
                templateId,
                userId
            });
            return res;
        },
        async pageInit(){
            this.isLoading = true;
            this.id = getUrlParam('id');
            this.openUrl = this.id ? `kwaiying://mv?id=${this.id}` : 'kwaiying://mv';
            const { data } = await this.getResource(getUrlParam('id'),getUrlParam('userId'));
            console.log('appdata==',data)
            if (data && data.result === 1) {
                //分享者信息
                if(data.userInfo !== null && data.userInfo !== undefined){
                    this.showShareInfo = true;
                    this.userInfo = data.userInfo;
                    this.registerDays = Math.floor(((new Date()).valueOf() - data.userInfo.registerTime) / (1000*3600*24));
                    console.log('注册天数---',this.registerDays)
                }
                const tempArr = data.sameTemplates||[]
                this.recData = tempArr.concat(data.hotTemplates);
                this.recData.unshift(data.mainTemplates)
                this.mainData = data.mainTemplates;
                this.mainVideoUrl = this.mainData.videoUrl;
                this.mainCoverUrl = this.mainData.templateBean.coverUrl;
                this.mainUserName = this.mainData.user.nickName;
                this.mainVideoDes = this.mainData.templateBean.description;
                this.mainUseCount = this.formalCount(this.mainData.templateBean.useCount,0);
                this.shareCardCount = this.formalCount(this.mainData.templateBean.useCount,1);
                const { w, h } = this.computedVideoSize(this.mainData.templateBean.width,this.mainData.templateBean.height);
                this.width = w;
                this.height = h;
                this.show = true;
                //ios兼容webp格式图片
                for(let i=0;i<this.recData.length;i++){
                    if(this.recData[i].templateBean.coverUrl.indexOf('webp') !== -1){
                        this.recData[i].templateBean.coverUrl = this.recData[i].templateBean.coverUrl.indexOf('?')
                        ? this.recData[i].templateBean.coverUrl + '.webp'
                        : this.recData[i].templateBean.coverUrl + '?_webp_type=webp.webp';
                    // 增加.webp后缀 webpMachine来识别处理
                    webpMachine.polyfillDocument();
                    }
                }
                if (this.mainCoverUrl.indexOf('webp') !== -1) {
                    this.mainCoverUrl = this.mainCoverUrl.indexOf('?')
                        ? this.mainCoverUrl + '.webp'
                        : this.mainCoverUrl + '?_webp_type=webp.webp';
                    webpMachine.polyfillDocument();
                }
                if(this.cardType === 'card1'){
                    let noDes ='导入照片或视频，一键免费制作视频'
                    let desText = `${this.mainData.templateBean.description || noDes},${this.shareCardCount}人一键做同款`;
                    wxShareConfig(
                        {
                            title: this.mainData.name || '',
                            desc: desText || '',
                            imgUrl: this.mainData.templateBean.coverUrl || '',
                        },
                        this.pageTag,
                    );
                }
                else{
                    wxShareConfig(
                        {
                            title: this.mainData.name || '',
                            desc: this.mainVideoDes || '',
                            imgUrl: this.mainData.templateBean.coverUrl || '',
                        },
                        this.pageTag,
                    );
                }
                
            }else {
                this.modelErrorMsg = this.$t('noTemplate');
                this.showError = true;
            }
            this.isLoading = false;
        },
        // 1280*720
        // 720*1280
        // 720*960
        // 目前有三种尺寸的视频，统一以视频宽度为基准等比缩放
        computedVideoSize(width, height) {
            let result = {};
            // CW具体取值取决于视觉稿,单位为px
            const CW =  window.screen.width;
            const per = width / CW;
            result = { w: CW, h: height / per  };
            return result;
        },
        // 埋点
        openKy(type,url) {
            this.$weblog.collect('CLICK', 'model_share_use_button', { btn_name: type, id: this.id });
            openOrDownloadKwaiying(url, 800);
        },
        wxOpenHandler(type, e) {
            this.$weblog.collect('CLICK', 'wx_button_launch_handler', {
                type,
                pageTag: this.pageTag,
                msg: JSON.stringify(e)
            });
            if (e?.detail?.errMsg === "launch:fail") {
                openOrDownloadKwaiying(this.openUrl, 800);
            }
        },
        formVideoData(){
            const cardWidth = 336;
            const cardBottomHeight = 122;
            let leftHeight = 0;
            let rightHeight = 0;
            this.recData.forEach((item, index) => {
                const { width, height } = item.templateBean;
                const curH = (height / width) * cardWidth + cardBottomHeight;
                if (leftHeight <= rightHeight) {
                    this.leftData.push({
                        ...item,
                        index,
                    });
                    leftHeight += curH;
                } else {
                    this.rightData.push({
                        ...item,
                        index,
                    });
                    rightHeight += curH;
                }
            });
        },

    },
    async mounted() {
        this.getAbValue({abParam:'Kuaiying_share_h5_card',webdid: getCookie('did') || getCookie('_did')});
        if (this.isWexin) {
            wxInit();
        }
        this.$weblog.collect('PV',  {
            share_url: location.href,
            page_name: getUrlParam('page_name')||'',
            page_type:'exp1'
        });
        await this.pageInit()
        this.getPlayState();
        this.formVideoData();
        console.log("auto-feed")
    },
};
</script>

<style lang="less" scoped>
#content {
    text-align: center;
    background-size: cover;
    width: 100vw;
    height: 100vh;
    position: relative;
    display: flex;
    justify-content: center;
    background: #141414;
}
.app-show-box {
    width: 100%;
    max-width: 500px;
    height: 100%;
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #141414;
}
// 模板页头部信息
.app-bar-msg {
    top: 0;
    z-index: 999;
    position: absolute;
    width: 100%;
    height: 1.2rem;
    background: #141414;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .app-bar-info{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .app-bar-icon{
            overflow: hidden;
            margin: 0 0.24rem 0 0.32rem;
            display: flex;
            justify-content: center;
            align-items: center;
            .icon-img{
                width: 0.76rem;
                height: 0.76rem;
                border-radius: 50%;
                overflow: hidden;
                border: 0.02rem solid #ffffff;
                box-shadow: 0rem 0.02rem 0.04rem 0rem rgba(0, 0, 0, 0.15);
            }
            .ky-icon{
                width: 0.72rem;
            }
            //解决css中1px不兼容问题
            // .img-icon:after{
            //     content: '';
            //     position: absolute;
            //     top: 0;
            //     left: 0;
            //     border: 0.02rem solid #ffffff;
            //     box-sizing: border-box;
            //     width: 200%;
            //     height: 200%;
            //     border-radius: 50%;
            //     box-shadow: 0rem 0.02rem 0.04rem 0rem rgba(0, 0, 0, 0.15);
            //     -webkit-transform: scale(0.5);
            //     transform: scale(0.5);
            //     -webkit-transform-origin: left top;
            //     transform-origin: left top;
            // }
        }
        .app-bar-txt{
            display: flex;
            flex-direction: column;
            .nick-name{
                font-size: 0.3rem;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                text-align: left;
                color: #ffffff;
                margin-bottom: 0.11rem;
            }
            .des{
                font-size: 0.22rem;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
                color: #727272;
            }
            .no-user{
                font-size: 0.26rem;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
                color: #727272;
            }
        }
    }
    .app-bar-btn{
        width: 1.2rem;
        height: 0.64rem;
        background: #262626;
        border-radius: 0.52rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 0.32rem;
        .btn-txt{
            font-size: 0.24rem;
            font-family: PingFangTC, PingFangTC-Semibold;
            font-weight: 600;
            color: rgba(255,255,255,0.9);
        }
    }
    .app-bar-img {
        width: 100%;
        height: auto;
    }
}
// .line{
//     margin-top: 1.2rem;
//     width: 100%;
//     height: 0.02rem;
//     border: 0.01rem solid rgba(255,255,255,0.08);
// }
//分享视频
.app-video-box {
    //padding-top: 1.2rem;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0 0 0.16rem 0.16rem;
    .app-video{
        overflow: hidden;
        border-radius: 0 0 0.16rem 0.16rem;
    }
}
//模板页使用信息以及底部button
.app-bottom-fixed {
    width: 100%;
    height: 4.2rem;
    position: fixed;
    overflow: hidden;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5) 32%, rgba(0, 0, 0, 0.6));
    .app-bottom-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.78rem 0.48rem 0.48rem 0.48rem;
        .app-bottom-user{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            .user-name{
                font-size: 0.34rem;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                text-align: justify;
                color: rgba(255,255,255,0.9);
                margin-bottom: 0.16rem;
            }
            .template-des{
                font-size: 0.26rem;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
                color: rgba(255,255,255,0.9);
                max-width: 4.28rem;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
        .app-bottom-info{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .info-line{
                width: 0.02rem;
                height: 0.8rem;
                background: rgba(255,255,255,0.2);
                margin-right: 0.41rem;
            }
            .template-use{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .use-count{
                    font-size: 0.38rem;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    text-align: right;
                    color: rgba(255,255,255,0.9);
                    margin-bottom: 0.16rem;
                }
                .use-txt{
                    font-size: 0.26rem;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: rgba(255,255,255,0.9);;
                }
            }
        }
    }
}

@keyframes btnBreath {
    0%{
        -webkit-transform: scale(0.88);
        -moz-transform:scale(0.88);
        transform: scale(0.88);
    }
    100%{
        -webkit-transform: scale(1);
        -moz-transform:scale(1);
        transform: scale(1);
    }
}

.app-use-btn {
    margin: 0 auto;
    width: 5.28rem;
    height: 1.04rem;
    border-radius: 0.52rem;
    background: linear-gradient(45deg,#F52C6F, #F7365D, #FF5151);
    overflow: hidden;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: btnBreath 0.5s ease-out alternate infinite;
    .btn-txt{
        font-size: 0.3rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: rgba(255,255,255,0.9);
    }
}

//推荐视频
.recommend-box{
    padding-bottom: 2.5rem;
    background-color: #141414;
    display: none;
    flex-direction: column;
    //justify-content: flex-start;
    .rec-bar{
        margin-top: 1.6rem;
        height: 0.32rem;
        //width: 100vw;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .rec-txt{
            font-size: 0.26rem;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            text-align: left;
            color: rgba(255,255,255,0.9);
            margin-left: 0.32rem;
        }
        .rec-try{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-right: 0.32rem;
            .try-txt{
                font-size: 0.26rem;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: right;
                color: rgba(255,255,255,0.4);
                margin-right: 0.04rem;
            }
            .try-arrow{
                display: flex;
                align-items: center;
                .try-img{
                    width: 0.32rem;
                }
            }
        }
    }
    .recommend-video{
        display: flex;
        justify-content: center;
        margin: 0 0.32rem;
        margin-top: 0.48rem;
        .left-feed{
            margin-right: 0.14rem;
        }
    }
    .rec-more-box {
        bottom: 0;
        left: 0;
        position: fixed;
        width: 100%;
        height: 2.1rem;
        z-index: 999;
       .rec-more-btn {
            margin: 0 auto;
            width: 5.28rem;
            height: 1.04rem;
            border-radius: 0.52rem;
            background: linear-gradient(45deg,#F52C6F, #F7365D, #FF5151);
            overflow: hidden;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            .more-btn-txt{
                font-size: 0.3rem;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                text-align: center;
                color: rgba(255,255,255,0.9);
            }
        }
    }
}
.app-exit-tip {
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-size: 100%;
    .exit-img {
        width: 4.8rem;
        height: 3rem;
        background-image: url('https://p4-ky.wsukwai.com/udata/pkg/kmovie/fontend-activity/ky_empty_source.8e152a61dfc81d49.png');
        background-size: 100% 100%;
        margin-bottom: 0.18rem;
    }
    .exit-text {
        width: 4.9rem;
        font-size: 0.26rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #666666;
        line-height: 0.4rem;
    }
}
</style>
